import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Alert,
  Box,
  Card,
  CardContent,
  Stack,
  Typography,
  Chip,
} from "@mui/material";
import { ArrowBack, Inventory } from "@mui/icons-material";
import auth from "../services/auth";
import InternalArchive from "../components/InternalArchive";

const InternalArchiveScreen = () => {
  const navigate = useNavigate();
  const user = auth.getCurrentUser();
  const companyId = user?.data?.companyId || user?.data?.id;

  if (!companyId) {
    return (
      <Box
        sx={{ p: { xs: 2, md: 4 }, background: "#f7f5fb", minHeight: "100vh" }}
      >
        <Alert severity="error">Não foi possível identificar a empresa.</Alert>
      </Box>
    );
  }

  return (
    <Box
      sx={{ p: { xs: 2, md: 4 }, background: "#f7f5fb", minHeight: "100vh" }}
    >
      <Card
        elevation={0}
        sx={{
          borderRadius: 4,
          mb: 3,
          background: "linear-gradient(90deg, #5b2c72 0%, #7b1fa2 100%)",
          color: "white",
        }}
      >
        <CardContent>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Inventory />
              <Typography variant="h5" fontWeight="bold">
                Arquivo Interno da Empresa
              </Typography>
            </Stack>
            <Chip
              label="Voltar"
              color="secondary"
              icon={<ArrowBack fontSize="small" />}
              onClick={() => navigate("/dashboard")}
            />
          </Stack>
        </CardContent>
      </Card>

      <InternalArchive companyId={companyId} />
    </Box>
  );
};

export default InternalArchiveScreen;
